var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { Button, Text, tombac, useToasts } from "tombac";
import { WhatsNewIcon } from "tombac-icons";
import { useLegoland } from "../LegolandContext";
import { useReleaseNotesQuery } from "../legolandApi";
import { useReleaseNotesMarkDismissed, useReleaseNotesStatus, } from "./releaseNotesHooks";
var ActionBar = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), tombac.space(1));
var ToastContent = function (_a) {
    var Link = _a.linkComponent, onRefreshClick = _a.onRefreshClick, onViewReleaseNotesClick = _a.onViewReleaseNotesClick, releaseNotesUrl = _a.releaseNotesUrl, showRefresh = _a.showRefresh;
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, null, "Check the release notes to learn more about the improvements and newest additions."),
        React.createElement(ActionBar, null,
            showRefresh && (React.createElement(Button, { "$mr": "1sp", onClick: onRefreshClick, size: "xs" }, "Refresh page")),
            React.createElement(Button, { as: Link, href: releaseNotesUrl, onClick: onViewReleaseNotesClick, size: "xs" }, "Learn what's new"))));
};
export var NewReleaseNotification = function () {
    var _a = useLegoland(), Link = _a.Link, releaseNotesUrl = _a.releaseNotesUrl;
    var _b = useToasts(), addToast = _b.addToast, dismissToast = _b.dismissToast;
    if (!releaseNotesUrl) {
        throw new Error("NewReleaseNotification component requires releaseNotesUrl prop to be set on LegolandApp.");
    }
    var rnQuery = useReleaseNotesQuery();
    var isDismissed = useReleaseNotesStatus().isDismissed;
    var markDismissed = useReleaseNotesMarkDismissed();
    var prevIsDismissed = useRef(undefined);
    useEffect(function () {
        var updatedInBg = false;
        var shouldReload = false;
        var shouldRedirect = false;
        if (isDismissed) {
            dismissToast("legoland-sdk.new-release");
        }
        if (prevIsDismissed.current === true && isDismissed === false) {
            updatedInBg = true;
        }
        if (isDismissed !== undefined) {
            prevIsDismissed.current = isDismissed;
        }
        if (isDismissed === false) {
            addToast("New release!", "default", {
                autoDismiss: false,
                content: (React.createElement(ToastContent, { linkComponent: Link, onRefreshClick: function () {
                        dismissToast("legoland-sdk.new-release");
                        shouldReload = true;
                    }, onViewReleaseNotesClick: function (e) {
                        dismissToast("legoland-sdk.new-release");
                        if (updatedInBg) {
                            e.preventDefault();
                            shouldReload = updatedInBg;
                            shouldRedirect = releaseNotesUrl;
                        }
                    }, releaseNotesUrl: releaseNotesUrl, showRefresh: updatedInBg })),
                icon: React.createElement(WhatsNewIcon, { size: "lg" }),
                id: "legoland-sdk.new-release",
                onDismiss: function () {
                    if (!rnQuery.data)
                        throw new Error("No release notes loaded.");
                    markDismissed(rnQuery.data);
                    if (shouldRedirect) {
                        if (shouldReload && window.location.pathname === shouldRedirect) {
                            window.location.reload();
                        }
                        else {
                            window.location.assign(shouldRedirect);
                        }
                    }
                    else if (shouldReload) {
                        window.location.reload();
                    }
                },
                placement: "bottom-right",
            });
        }
    }, [isDismissed]);
    return null;
};
var templateObject_1;
//# sourceMappingURL=NewReleaseNotification.js.map